import "./App.css";

function App() {
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <a
        className="px-2 py-1 bg-green-500 hover:bg-green-400"
        href="mailto:ganesh.gupta@adityabirlacapital.com?subject=Change%20My%20Alternate%20Mobile%20Numbe.r&body=Please%20change%20my%20Alternate%20Mobile%20Number%20for%0D%0A%0D%0APolicy%20Number:%2023-19-0002637-04%20from%209222514364%20to%209167126442%0D%0A%0D%0AThank%20You."
      >
        Send E-Mail
      </a>
    </div>
  );
}

export default App;
